<ngx-loading-bar [includeSpinner]='false'></ngx-loading-bar>
<i2a-page-container>
    <ng-container content-body>
        <router-outlet></router-outlet>
    </ng-container>
</i2a-page-container>